import React from "react"
import PropTypes from "prop-types"
import { FormControl, FormGroup, FormText } from "react-bootstrap"
import LoadingButton from "components/LoadingButton" // eslint-disable-line import/no-named-as-default
import { ENTERKEY } from "imports/desktopConstants"
import { helpTexts } from "sheets/components/helpTexts"
import ImmutablePropTypes from "react-immutable-proptypes"

export function FieldGroup({ id, label, handleKeyPress, help, validationState, ...props }) {
    return (
        <FormGroup controlId={id} validationState={validationState} onKeyPress={handleKeyPress}>
            {label}
            <FormControl {...props} />
            {help && validationState === "error" && <FormText style={{ fontSize: "12px" }}>{help}</FormText>}
        </FormGroup>
    )
}

/**
 * Component to render two inputs to be able to filter for minimum / maximum values of a column in sheets
 * and resource tables
 */
export default class ColumnSearchNumberRange extends React.Component {
    constructor(props) {
        super(props)

        // the minimum and maximum values of the column
        this.state = {
            min: 0,
            max: 10000000,
        }
    }

    componentDidMount() {
        // if we have been searching for a value, make sure the component shows the user
        if (this.props.value) {
            const [min, max] = this.props.value
            this.setState({ min, max })
        }
    }

    // return true if the value supplied meets validation criteria
    validateValue = (value) => {
        if (!parseFloat(value) && parseFloat(value) !== 0) {
            return false
        }
        return true
    }

    // function handler for the FormGroup
    getMinValidationState = () => {
        if (!this.validateValue(this.state.min)) {
            return "error"
        }
        return null
    }

    // function handler for the FormGroup
    getMaxValidationState = () => {
        if (!this.validateValue(this.state.max)) {
            return "error"
        }
        return null
    }

    handleMinChange = (event) => {
        this.setState({ min: event.target.value })
    }

    handleMaxChange = (event) => {
        this.setState({ max: event.target.value })
    }

    handleFilter = () => {
        if (this.validateValue(this.state.min) && this.validateValue(this.state.max)) {
            this.props.search([this.state.min, this.state.max])
        }
    }

    // if the user hit enter in one of the inputs, and we aren't loading, let's filter
    handleKeyPress = (e) => {
        if (["Enter", ENTERKEY].includes(e.key) && !this.props.loading) {
            this.handleFilter()
        }
    }

    render() {
        return (
            <div>
                {/* The lower bound of the search  */}
                <FieldGroup
                    data-cy="minValue"
                    handleKeyPress={this.handleKeyPress}
                    help={helpTexts.validNumber}
                    id="minValue"
                    label="Minimum"
                    onChange={this.handleMinChange}
                    placeholder="Minimum value..."
                    type="number"
                    validationState={this.getMinValidationState()}
                    value={this.state.min}
                />
                <FieldGroup
                    data-cy="maxValue"
                    handleKeyPress={this.handleKeyPress}
                    id="maxValue"
                    label="Maximum"
                    onChange={this.handleMaxChange}
                    placeholder="Maximum value..."
                    type="number"
                    validationState={this.getMaxValidationState()}
                    value={this.state.max}
                />
                <LoadingButton
                    block
                    variant="primary"
                    bsSize="sm"
                    buttonText="Filter"
                    dataCy="columnFilter"
                    isLoading={this.props.loading}
                    loadingText={"Filtering..."}
                    onClick={this.handleFilter}
                    style={{ marginTop: "10px" }}
                />
            </div>
        )
    }
}

ColumnSearchNumberRange.propTypes = {
    loading: PropTypes.bool.isRequired,
    search: PropTypes.func.isRequired,
    value: ImmutablePropTypes.list,
}

ColumnSearchNumberRange.defaultProps = {
    value: null,
}
